import React from 'react';
import axios from 'axios';
import { 
  Table, 
  Input, 
  Button, 
  Collapse, 
  Popover, 
  Switch, 
  message, 
  Spin, 
  Avatar,
  Modal,
  Form,
  Tabs
} from 'antd';
import Highlighter from 'react-highlight-words';
import { 
  SearchOutlined, 
  FundViewOutlined, 
  LockFilled, 
  UserOutlined, 
  DownloadOutlined,
  LockOutlined,
  FileTextOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../../serverconn';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import DeliveryAgentForm from '../components/DeliveryAgentForm';
import AgentRights from '../components/AgentRights';
import ProfessionalLayout from '../../../components/ProfessionalLayout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

const CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let ngoid = '';
let bizuserid = '';
let token = '';

class AgentList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    delivery_agents: [],
    datarequested: true,
    userrights: {},
    selectedid: '',
    showpasswordupdatemodal: false,
    new_password: '',
    activeTab: 'riders',
  };

  componentDidMount() {
    this.initializeAuth();
    this.componentmountactions();
  }

  initializeAuth = () => {
    if (localStorage.getItem("ngoid")) {
      ngoid = CryptoJS.AES.decrypt(localStorage.getItem("ngoid"), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
    }
    
    if (localStorage.getItem("bizuserid")) {
      bizuserid = CryptoJS.AES.decrypt(localStorage.getItem("bizuserid"), 'my-secret-key@1234').toString(CryptoJS.enc.Utf8);
    }
    
    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    };
  }

  componentmountactions = () => {
    axios.get(`${serverconfig.backendserverurl}/api/delivery_agents/`)
      .then(res => {
        this.setState({
          delivery_agents: res.data
        });
      })
      .catch(error => console.error('Error loading agents:', error));

    axios.get(`${serverconfig.backendserverurl}/api/accountrights/?user=${bizuserid}`)
      .then(res => {
        this.setState({
          userrights: res.data[0],
          datarequested: false
        });
      })
      .catch(error => {
        console.error('Error loading user rights:', error);
        this.setState({ datarequested: false });
      });
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  handleTabChange = (activeKey) => {
    this.setState({ activeTab: activeKey });
  };

  getFilteredAgents = () => {
    const { delivery_agents, activeTab } = this.state;
    
    if (activeTab === 'riders') {
      return delivery_agents.filter(agent => agent.agent_type === 'rider');
    } else if (activeTab === 'entrants') {
      return delivery_agents.filter(agent => agent.agent_type === 'entrant');
    }
    
    return delivery_agents;
  };

  getAgentCounts = () => {
    const { delivery_agents } = this.state;
    const riders = delivery_agents.filter(agent => agent.agent_type === 'rider').length;
    const entrants = delivery_agents.filter(agent => agent.agent_type === 'entrant').length;
    const total = delivery_agents.length;
    
    return { riders, entrants, total };
  };

  handlePrint = () => {
    const { activeTab } = this.state;
    const filteredAgents = this.getFilteredAgents();
    const agentType = activeTab === 'riders' ? 'Riders' : 'Entrants';
    
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>${agentType} Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { color: #1890ff; text-align: center; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f5f5f5; font-weight: bold; }
            .agent-type { text-transform: capitalize; }
            .status { font-weight: bold; }
            .online { color: #52c41a; }
            .offline { color: #8c8c8c; }
            .active { color: #52c41a; }
            .inactive { color: #ff4d4f; }
          </style>
        </head>
        <body>
          <h1>${agentType} Report - ${new Date().toLocaleDateString()}</h1>
          <p>Total ${agentType.toLowerCase()}: ${filteredAgents.length}</p>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Agent Code</th>
                <th>Hub</th>
                <th>Phone</th>
                <th>ID Number</th>
                <th>Agent Type</th>
                <th>Status</th>
                <th>Online</th>
                <th>Last Login</th>
              </tr>
            </thead>
            <tbody>
              ${filteredAgents.map(agent => `
                <tr>
                  <td>${agent.FullName || 'N/A'}</td>
                  <td>${agent.agent_code || 'N/A'}</td>
                  <td>${agent.hub_name || 'N/A'}</td>
                  <td>${agent.RegisteredPhoneNumber1 || 'N/A'}</td>
                  <td>${agent.IDNumber || 'N/A'}</td>
                  <td class="agent-type">${agent.agent_type || 'N/A'}</td>
                  <td class="status ${agent.active ? 'active' : 'inactive'}">
                    ${agent.active ? 'Active' : 'Inactive'}
                  </td>
                  <td class="status ${agent.is_online ? 'online' : 'offline'}">
                    ${agent.is_online ? 'Online' : 'Offline'}
                  </td>
                  <td>${agent.login_at || 'Never'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  render() {
    const { delivery_agents, datarequested, activeTab } = this.state;
    const filteredAgents = this.getFilteredAgents();
    const { riders, entrants, total } = this.getAgentCounts();

    const columns = [
      {
        title: 'Profile',
        dataIndex: 'profile_pic',
        key: 'profile_pic',
        render: (text, record) => 
          <Avatar
            size={60}
            icon={<UserOutlined />}
            alt="User Pic"
            src={record.Photo}
          />,
      },
      {
        title: 'Agent Type',
        dataIndex: 'agent_type',
        key: 'id',
        ...this.getColumnSearchProps('agent_type'),
      },
      {
        title: 'Names',
        dataIndex: 'FullName',
        key: 'id',
        ...this.getColumnSearchProps('FullName'),
      },
      {
        title: 'Hub',
        dataIndex: 'hub_name',
        key: 'id',
        ...this.getColumnSearchProps('hub_name'),
      },

      {
        title: 'Agent code',
        dataIndex: 'agent_code',
        key: 'id',
        ...this.getColumnSearchProps('agent_code'),
      },

      {
        title: 'Phone contact',
        dataIndex: 'RegisteredPhoneNumber1',
        key: 'id',
      },
      {
        title: 'ID',
        dataIndex: 'IDNumber',
        key: 'id',
      },
      {
        title: 'Last login',
        dataIndex: 'login_at',
        key: 'id',
      },
      {
        title: 'Last logout',
        dataIndex: 'logout_at',
        key: 'id',
      },
      {
        title: 'Active?',
        dataIndex: 'id',
        key: 'id',
        render: (text, record) =>
          <Switch
            checked={record.active}
            onChange={val => {
              const form_data = new FormData();
              form_data.append('is_online', record.is_online);
              form_data.append('active', val);
              
              axios.put(`${serverconfig.backendserverurl}/api/delivery_agents/${record.id}/`, form_data, {
                headers: {
                  'content-type': 'multipart/form-data'
                }
              })
              .then(res => {
                this.componentmountactions();
                message.success("Agent status updated successfully");
              })
              .catch(error => {
                console.error('Error updating agent:', error);
                message.error("Failed to update agent status");
              });
            }}
            checkedChildren="Yes"
            unCheckedChildren="No"
          />
      },
      {
        title: 'Online?',
        dataIndex: 'id',
        key: 'id',
        render: (text, record) =>
          <span style={{ 
            color: record.is_online ? '#52c41a' : '#8c8c8c',
            fontWeight: 'bold'
          }}>
            {record.is_online ? "●  Online" : "○  Offline"}
          </span>
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'id',
        render: (text, record) =>
          <div style={{ display: 'flex', gap: 8 }}>
            <Popover content="View and edit agent details" title="Agent Details">
              <Link to={`/deliveryagents/${text}`}>
                <FundViewOutlined style={{ color: '#1890ff', fontSize: 16 }} />
              </Link>
            </Popover>
            
            <Popover content="Change agent password" title="Password Change">
              <LockFilled 
                style={{ color: '#722ed1', fontSize: 16, cursor: 'pointer' }}
                onClick={() => {
                  this.setState({
                    showpasswordupdatemodal: true,
                    selectedid: text
                  });
                }}
              />
            </Popover>

            <AgentRights agentId={record.id} agentName={record.FullName} />
          </div>,
      },
    ];

    const headerActions = (
      <div style={{ display: 'flex', gap: 12 }}>
        <Button 
          type="default" 
          icon={<PrinterOutlined />}
          onClick={this.handlePrint}
          className="professional-button"
        >
          Print {activeTab === 'riders' ? 'Riders' : 'Entrants'}
        </Button>
        
        <ExcelFile 
          filename={`UmojaIMCouriers-${activeTab === 'riders' ? 'Riders' : 'Entrants'}-${new Date().toISOString().split('T')[0]}`} 
          element={
            <Button 
              type="primary" 
              icon={<DownloadOutlined />}
              className="professional-button professional-button-primary"
            >
              Export Excel
            </Button>
          }
        >
          <ExcelSheet data={filteredAgents} name={`${activeTab}_agents`}>
            <ExcelColumn label="Name" value="FullName"/>
            <ExcelColumn label="Agent Code" value="agent_code"/>
            <ExcelColumn label="Hub" value="hub_name"/>
            <ExcelColumn label="Phone" value="RegisteredPhoneNumber1"/>
            <ExcelColumn label="ID Number" value="IDNumber"/>
            <ExcelColumn label="Agent Type" value="agent_type"/>
            <ExcelColumn label="Active" value="active"/>
            <ExcelColumn label="Online" value="is_online"/>
            <ExcelColumn label="Last Login" value="login_at"/>
            <ExcelColumn label="Last Logout" value="logout_at"/>
          </ExcelSheet>
        </ExcelFile>
      </div>
    );

    return (
      <div>
         <ProfessionalLayout
        title="Delivery Agents Management"
        subtitle={`Manage and monitor ${filteredAgents.length} ${activeTab === 'riders' ? 'riders' : 'entrants'} (${total} total: ${riders} riders, ${entrants} entrants)`}
        icon={<ManageAccountsIcon />}
        headerActions={headerActions}
        loading={datarequested}
      >
        {!datarequested && (
          <>
            <div className="professional-content" style={{ marginBottom: 24 }}>
              <Tabs 
                activeKey={activeTab} 
                onChange={this.handleTabChange}
                type="card"
                size="large"
                style={{ 
                  background: '#fff',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
                items={[
                  {
                    key: 'riders',
                    label: (
                      <span>
                        <UserOutlined style={{ marginRight: 8 }} />
                        Riders ({riders})
                      </span>
                    ),
                    children: (
                      <Table
                        scroll={{ x: 1000 }}
                        columns={columns}
                        pagination={{
                          showQuickJumper: true,
                          showSizeChanger: true,
                          showTotal: (total, range) => 
                            `${range[0]}-${range[1]} of ${total} riders`
                        }}
                        dataSource={filteredAgents}
                        bordered
                        size="middle"
                      />
                    )
                  },
                  {
                    key: 'entrants',
                    label: (
                      <span>
                        <FileTextOutlined style={{ marginRight: 8 }} />
                        Entrants ({entrants})
                      </span>
                    ),
                    children: (
                      <Table
                        scroll={{ x: 1000 }}
                        columns={columns}
                        pagination={{
                          showQuickJumper: true,
                          showSizeChanger: true,
                          showTotal: (total, range) => 
                            `${range[0]}-${range[1]} of ${total} entrants`
                        }}
                        dataSource={filteredAgents}
                        bordered
                        size="middle"
                      />
                    )
                  }
                ]}
              />
            </div>

            <Collapse 
              className="professional-form"
              defaultActiveKey={[]}
            >
              <Panel 
                header={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <UserOutlined style={{ color: '#1890ff' }} />
                    <span style={{ fontWeight: 500 }}>Add New Agent</span>
                  </div>
                }
                key="1"
              >
                <div>
                  <h3 style={{ marginBottom: 16, color: '#333' }}>Create New Agent</h3>
                  <DeliveryAgentForm />
                </div>
              </Panel>
            </Collapse>
          </>
        )}


      </ProfessionalLayout>



      <Modal              
        visible={this.state.showpasswordupdatemodal}
        title="Password change Form"
        width={600}
        onCancel={() => this.setState({ showpasswordupdatemodal: false })}

        footer={[
          <Button key="back" onClick={() => this.setState({ showpasswordupdatemodal: false })}>
            Cancel
          </Button>,
          <Button 
            key="submit" 
            type="primary"  
            onClick={() => {
              if (!this.state.new_password) {
                message.error("Please enter a new password");
                return;
              }

              if (this.state.new_password.length < 6) {
                message.error("Password must be at least 6 characters long");
                return;
              }

              // Prepare form data for password update
              if (!this.state.selectedid) {
                message.error("No agent selected for password update");
                return;
              }


              const form_data = new FormData();
              form_data.append('password', this.state.new_password);
              form_data.append('agent_id', this.state.selectedid);

              axios.post(`${serverconfig.backendserverurl}/customqueries/updateagentpassword`, form_data, {
                headers: {
                  'content-type': 'multipart/form-data'
                }
              })
              .then(res => {
                message.success("Password updated successfully");
                this.setState({ showpasswordupdatemodal: false });
              })
              .catch(error => {
                console.error('Error updating password:', error);
                message.error("Failed to update password");
              });


            }}
          >
            Update Password
          </Button>
          ]}
          >

            <Form.Item
                name="new_password1"
                label="New Password one"
              >
            <Input.Password 
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password one"
            onChange={e => this.setState({ new_password: e.target.value })}
            value={this.state.new_password}
          />
          </Form.Item>

            
    </Modal>





      </div>
     
    );
  }
}

export default AgentList; 
